import UltMeta, { Meta } from "./UltMeta/index";

class Type extends UltMeta {
    LIAN_YUN = new Meta(1, "志豪链云");
    SHIP = new Meta(2, "链云船务");
}

export const TYPE = new Type();

class IsForce extends UltMeta {
    YES = new Meta(1, "是");
    NO = new Meta(0, "否");
}

export const IS_FORCE = new IsForce();
